import type { ReactNode } from "react";
import { QueryProvider } from "@/app/QueryProvider";

export function AppProviders({ children }: { children: ReactNode }) {
  return <QueryProvider>{children}</QueryProvider>;
}
